<div>
    <app-project-status [selectedProject]="selectedProject" [selectedProjectStatus]="selectedProjectStatus"></app-project-status>
    <app-eea-output-view
      [selectedProject]="selectedProject"
      [isProjectOwnershipValid]="isProjectOwnershipValid"
    />
</div>
